import "./assets/css/bootstrap.min.css";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";
import "./assets/sass/application.css";
import "tachyons";

import * as Sentry from "@sentry/browser";
import * as serviceWorker from "./serviceWorker";

import { ApolloLink, split } from "apollo-link";
//import { render } from 'react-snapshot';
import { IntlProvider, addLocaleData } from "react-intl";

import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";
// const navigator = require('navigator');
import App from "./containers/App/App";
import { InMemoryCache } from "apollo-cache-inmemory";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { WebSocketLink } from "apollo-link-ws";
import asyncComponent from "./components/AsyncComponent";
import { createHttpLink } from "apollo-link-http";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import fr from "react-intl/locale-data/fr";
import { getMainDefinition } from "apollo-utilities";
//Our translated strings
import localeData from "./translations/translation.json";
import { onError } from "apollo-link-error";
import { persistCache } from "apollo-cache-persist";

if (process.env.REACT_APP_RUNNING_ENV === "production") {
  Sentry.init({
    dsn: "https://f3b26e2ccab94b10bf33678c2f89d4c8@sentry.io/1778670"
  });
}

addLocaleData([
  ...fr,
  ...en,
  ...es
  // ...it
]);

//dummy force build

console.log(
  "process.env.REACT_APP_GRAPHQL_ENDPOINT ",
  process.env.REACT_APP_GRAPHQL_ENDPOINT
);

console.log("process.env.REACT_APP_VERSION ", process.env.REACT_APP_VERSION);

const httpLink = createHttpLink({
  uri:
    process.env.REACT_APP_GRAPHQL_ENDPOINT + "/graphql"
      ? process.env.REACT_APP_GRAPHQL_ENDPOINT + "/graphql"
      : "https://api.graph.cool/simple/v1/cjab8vyzt0qw10152094iyml7"
});

const uri = process.env.REACT_APP_GRAPHQL_ENDPOINT.replace(`http`, `ws`);

// Create a WebSocket link:
const wsLink = new WebSocketLink({
  uri, // process.env.REACT_APP_GRAPHQL_ENDPOINT.replace(`http`, `ws`),
  options: {
    reconnect: true,
    reconnectionAttempts: 50,
    // lazy: true,
    // timeout: 10000,
    keepAlive: 10000,
    connectionCallback: (error, result) => {
      console.log("connection callback", error, result);
    },
    inactivityTimeout: 0
    // onConnect: () => {
    //   console.log("reconnecting...........................");
    // },
    // onOperationComplete: (socket, opt) => {
    //   console.log(
    //     "onOperationComplete...........................",
    //     socket,
    //     opt
    //   );
    // }
  }
});

const middlewareLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem("graphcoolToken");
  const authorizationHeader = token ? `Bearer ${token}` : "";
  operation.setContext({
    headers: {
      authorization: authorizationHeader
    }
  });
  // console.log('load token', token);
  return forward(operation);
});

const onErrorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path, history }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
      if (message === "Not authorized") {
        window.location.href = window.location.origin + "/companies";
      }
      return undefined; // avoid warning
    });

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const httpLinkWithAuthToken = ApolloLink.from([
  middlewareLink,
  onErrorLink,
  httpLink
]);

// .concat(onErrorLink); //.concat(wsLink);
const link = split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === "OperationDefinition" && operation === "subscription";
  },
  // onErrorLink,
  wsLink,
  httpLinkWithAuthToken
);

const cache = new InMemoryCache();
persistCache({
  cache,
  storage: window.sessionStorage,
  // maxSize: false,
  debug: true,
  debounce: 10000, // 10s debounce
  trigger: false, // disable cache persistence
  maxSize: 1048576
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: "cache-and-network",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "network-only",
    errorPolicy: "all"
  },
  mutate: {
    fetchPolicy: "no-cache",
    errorPolicy: "all"
  }
};

let client;
try {
  client = new ApolloClient({
    link: link, //httpLinkWithAuthToken,
    cache,
    // cache: new InMemoryCache()
    //   .restore(window.__APOLLO_STATE__),
    defaultOptions
  });
} catch (e) {
  alert("catched new ApolloClient", e);
  console.log("catched", e);
}

// window.client = client;

// Define user's language. Different browsers have the user locale defined on
// different fields on the `navigator` object, so we make sure to account for
// these different by checking all of them
const language =
  (window.navigator.languages && window.navigator.languages[0]) ||
  window.navigator.language ||
  window.navigator.userLanguage;

// Split locales with a region code
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

const rootEl = document.getElementById("root");

// Try full locale, try locale without region code, fallback to 'en'
const messages =
  localeData[languageWithoutRegionCode] ||
  localeData[language] ||
  localeData.fr;
// console.log('messages', messages)
ReactDOM.render(
  //render(
  <ApolloProvider client={client}>
    <IntlProvider locale={language} messages={messages}>
      <Router>
        <App />
      </Router>
    </IntlProvider>
  </ApolloProvider>,
  rootEl
);

if (module.hot) {
  //  import { WebGLRenderer } from 'three';
  const AsyncWebGLRenderer = asyncComponent(() => import("three"));

  const renderer = new AsyncWebGLRenderer({ antialias: true });
  module.hot.accept("./containers/App/App", () => {
    const NextApp = require("./containers/App/App").default;
    ReactDOM.render(
      //  render(
      <ApolloProvider client={client}>
        <IntlProvider locale={language} messages={messages}>
          <Router>
            <NextApp renderer={renderer} />
          </Router>
        </IntlProvider>
      </ApolloProvider>,
      rootEl
    );
  });
}

const config = {
  onUpdate: () => {
    // Append dispatch event
    // New content is available once existing tabs are closed.
    const event = new Event("newContentAvailable");
    console.log("dispatch new content event", event);
    window.dispatchEvent(event);
  }
};
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister(config);
